<template>
  <div class="login_container" >
    <div class="form_login" >
      <v-form
          ref="form"
          v-model="valid"
          lazy-validation
      >

        <div align="center" >
          <img class="logo-img" src="../assets/logo.png" />
        </div>

        <v-text-field
            v-model="email"
            :rules="email_rules"
            label="อีเมล"
            required
        ></v-text-field>

        <v-text-field
            v-model="password"
            :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show_password ? 'text' : 'password'"
            name="input-10-1"
            label="รหัสผ่าน"
            counter
            @click:append="show_password = !show_password"
        ></v-text-field>

        <div align="center" style="margin-top: 2rem" >
          <v-btn
              class="mr-4 btn-primary-custom"
              @click="validate"
          >
            เข้าสู่ระบบ
          </v-btn>

          <v-btn
              class="mr-4 btn-cancel-custom"
              @click="reset"
          >
            ล้างข้อมูล
          </v-btn><br><br>
          <font v-if="notfound" class="notfound" >ไม่พบชื่อผู้ใช้งาน</font>
        </div>

      </v-form>



    </div>
  </div>
</template>
<script>
// @ is an alias to /src

//import $ from "jquery";

import { auth} from "../lib/controller_auth";
import { jwtDecode } from "jwt-decode";

export default {
  name: 'Home',
  data: () => ({
    password: '',
    email: '',
    valid: true,
    notfound: false,
    show_password: false,
    rules: {
      required: value => !!value || 'กรอกรหัสผ่าน.',
    },
    email_rules: [
      v => !!v || 'อีเมลต้องไม่เป็นค่าว่าง',
      v => /.+@.+\..+/.test(v) || 'รูปแบบอีเมลไม่ถูกต้อง',
    ],
  }),

  methods:{
    validate () {
      this.notfound = false;
      if(this.$refs.form.validate()){
        this.Login();
      }
    },
    async Login(){
      this.notfound = false;
      const param = {
        "email":this.email,
        "password":this.password,
      }
      const { status , results,error } = await auth(param);
      console.log(error)
      if(results.code === 200){
        let Users = JSON.stringify(results.data.user);
        localStorage.setItem('user',Users)
        localStorage.setItem('access_token',results.data.access_token)
        window.location = "/"
        console.log(status)
        console.log(results)
      }else{
        this.notfound = true;
        console.log(results)
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    CheckLogin(){
      const UserData = localStorage.getItem('user');
      const access_token = localStorage.getItem('access_token');
      const access_token_decode = jwtDecode(access_token);
      console.warn(access_token_decode);
      if(UserData){
        console.log("Islogin")
        window.location = "/"
      }else{
        //console.log("Nologin")
      }
    }
  },
  mounted() {
    this.CheckLogin();
  }
}
</script>
<style>

body{
  background: #EBEDF3;
}
.form_login{
  width: 50rem;
  height: auto;
  padding:1.5rem;
  background: #ffffff;
  border-radius: 0.5rem;
}
.login_container{
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: #103388;
  background-image: url("../assets/side-bar-bg.png");
  background-repeat: no-repeat;
  background-position: bottom right;
}
.notfound{
  font-size: 1rem;
  color: red;
}
.logo-img{
  width: 7rem;
  height: 7rem;
}
</style>
